import React, { useState, useEffect, useCallback, useReducer } from 'react';

import { Helmet } from 'react-helmet';
import LWCLayout from '../layouts/LWCLayout';
import FormUtils from '../utils/FormUtils';
import ReCAPTCHA from "react-google-recaptcha";

const contributeMentor = ['Lead a Meetup Group', 'Meetup Speaker', 'Write Technical Content', 'Create Video Tutorials', 'Mentor others', 'Active on the MuleSoft Forum', 'Other'];

const expInSalesforce = ['Anypoint Platform', 'MuleSoft Composer', 'MuleSoft RPA', 'Salesforce Cloud Products', 'Tableau', 'Slack', 'None of the above'];

const forms = ['applyyourself', 'nominateSomeone'];

const MulesoftMentors = ({ pageContext }) => {
    const [countryList, setCountryList] = useState();
    const [isSiteDown, setSiteDown] = useState();
    const [formType, setFormType] = useState();
    const [isLoading, setLoading] = useState(false);
    const [apiMessage, setApiMessage] = useState(false);
    const [isLoggedUser, setloggedUser] = useState();
    const [urlError, setUrlError] = useState(false);
    const [recaptchaToken, setRecaptchaToken] = useState('')
    const recaptchaRef = React.createRef();
    const showFormMap = FormUtils.mulesoftFormDates();

    const utcDate = new Date();
    // const formattedPST = '09/2026';
    const formattedPST = utcDate.toLocaleString("en-US", {
        timeZone: "America/Los_Angeles", // Set the time zone to PST
        hour12: true,
        year: "numeric",
        month: "2-digit"
    });

    useEffect(() => {
        if (formattedPST) {
            const splitDash = formattedPST.split('/');
            const formInfo = showFormMap[`${splitDash[0]}${splitDash[1]}`];
            setSiteDown(formInfo);
        }
    }, [])

    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);
        const pageParams = searchParams.get('page');
        if (pageParams) {
            const trimedParam = pageParams.trim();
            const errorInUrl = forms.includes(trimedParam);
            setUrlError(!errorInUrl);
            if (errorInUrl) {
                setFormType(trimedParam);
                if (trimedParam === 'applyyourself') {
                    const loggedUser = localStorage.getItem('tbid');
                    if (!loggedUser) {
                        const origin = window.location.origin;
                        const pathName = 'sessions/users/new?type=tbidlogin';
                        window.location = `${origin}/${pathName}`;
                    } else {
                        setloggedUser(loggedUser)
                    }
                }
            }
        } else {
            setUrlError(true);
        }
    }, [])

    const inputReducer = (state, action) => {
        switch (action?.type) {
            case "CLEARSTATE":
                return {};
            default:
                return { ...state, [action.id]: action.value };
        }
    }

    const [inputValues, dispatchFieldChanges] = useReducer(inputReducer, {});
    const [fieldErrors, dispatchFieldErrorsChanges] = useReducer(inputReducer, {});

    useEffect(() => {
        if (!urlError) {
            getListOfCountries();
            asyncPrepareFields();
        }
    }, []);

    useEffect(() => {
        if (countryList?.length > 0) {
            setComboOptions();
        }
    }, [countryList]);

    useEffect(() => {
        if (inputValues['Country']) {
            const selectedCountry = countryList?.filter(country => country.label === inputValues['Country']);
            dispatchFieldChanges({ id: 'termsAndCondition', value: selectedCountry[0] });
            dispatchFieldErrorsChanges({ id: 'legalText', value: null });
            dispatchFieldChanges({ id: 'legalText', value: null });
            asyncPrepareFields();
        }
    }, [inputValues['Country']])

    const getListOfCountries = useCallback(() => {
        fetch(process.env.GATSBY_COUNTRY_LIST_ENDPOINT).then(r => r.json()).then(data => {
            setCountryList(data)
        })
    }, []);

    const setComboOptions = () => {
        customElements.whenDefined("tds-combobox").then(() => {
            const dropdownsOptions = { ...getDropdownsOptions() }

            if (countryList?.length > 0) {
                dropdownsOptions['Country'] = countryList.map(item => item.label);
            }

            Object.keys(dropdownsOptions).forEach(combo => {
                const comboEl = document.querySelector(`#${combo}`);

                if (comboEl && comboEl.dataset && !Object.hasOwnProperty.call(comboEl.dataset, 'alreadySetOptions')) {
                    comboEl.dataset.alreadySetOptions = true;
                    comboEl.options = dropdownsOptions[combo].map(item => { return { label: item, value: item } });
                }
            })
        })
    }

    const handleSubmitForm = (e) => {
        e.preventDefault();
        const hasAnyFormErrors = validateFields();

        if (!hasAnyFormErrors) {
            let formObject = {};
            let consentValue = '';
            let optInValue = '';

            if (inputValues['termsAndCondition']?.showMarketingText) {
                consentValue = 'Explicit';
                optInValue = !!inputValues['Privacy_Consent__c'];
            } else {
                consentValue = 'Implied';
                optInValue = true;
            }

            formObject['handlerName'] = 'mulesoft_mentor_form';
            formObject['Nominee_First_Name__c'] = inputValues['FirstName'].trim();
            formObject['Nominee_Last_Name__c'] = inputValues['LastName'].trim();
            formObject['Nominee_Email__c'] = inputValues['Email'];
            formObject['Nominee_Title__c'] = inputValues['Title'].trim();
            formObject['Nominee_Company__c'] = inputValues['Company'].trim();
            formObject['Nominee_Country__c'] = inputValues['Country'];
            formObject['Nominee_LinkedIn_URL__c'] = inputValues['LinkedIn_URL'];
            formObject['Role__c'] = inputValues['role'];
            formObject['Privacy_Consent__c'] = true;
            formObject['Opt_In_Check__c'] = optInValue;
            formObject['Consent__c'] = consentValue;

            // Apply to become Mulesoft Mentor Objects

            if (formType === 'applyyourself') {
                let expInSalesforceList = [];
                let contributeMentorList = [];

                formObject['MuleSoft_Certified__c'] = inputValues['mulesoftCertified'];
                formObject['TBID__c'] = isLoggedUser;

                expInSalesforce.forEach(items => {
                    if (inputValues[items]) {
                        expInSalesforceList.push(items);
                    }
                });

                formObject['Experienced_MuleSoft_Salesforce_Products__c'] = expInSalesforceList.join(';');

                contributeMentor.forEach(items => {
                    if (inputValues[items]) {
                        contributeMentorList.push(items);
                    }
                })

                formObject['Plan_To_Contribute_As_A_Mentor__c'] = contributeMentorList.join(';');
                formObject['Reason_To_Be_A_MuleSoft_Mentor__c'] = inputValues['mulesoftMentorreasons'];
                formObject['Member_Of_The_Salesforce_Trailblazer__c'] = inputValues['trailblazerMember'];
            }

            // Referrer Information Objects

            if (formType === 'nominateSomeone') {
                formObject['Nominator_First_Name__c'] = inputValues['ReferrerName'].trim();
                formObject['Nominator_Last_Name__c'] = inputValues['ReferrerLastName'].trim();
                formObject['Nominator_Email__c'] = inputValues['Referreremail'];
                formObject['Nominator_LinkedIn_URL__c'] = inputValues['ReferrerURL'];
                formObject['How_Do_You_Know_The_Nominee__c'] = inputValues['howdoyouknowthisperson'];
                formObject['Reason_To_Be_A_MuleSoft_Mentor__c'] = inputValues['goodMulesoftMentor'];
            }

            setLoading(true);

            fetch(process.env.GATSBY_MULESOFT_DRM_END_POINT, {
                method: 'POST',
                mode: 'cors',
                referrerPolicy: 'origin-when-cross-origin',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Captcha-Response': recaptchaToken,
                    'Access-Control-Allow-Headers': 'origin, X-Custom-Header',
                    'Access-Control-Allow-Method': 'POST',
                    'Access-Control-Allow-Origin': '*'
                },
                body: JSON.stringify(formObject)

            }).then(res => res.json()).then(res => {
                setLoading(false);
                setApiMessage(res);
                if (res?.status === 'success') {
                    window.setTimeout(function () {
                        window.location = "https://www.mulesoft.com/community/mentors";
                    }, 3000);
                }
            });

        }
    }


    const handleTdsTextareaOnChange = useCallback(e => {
        const val = e.nativeEvent ? e.nativeEvent.target.value : e.detail
        const inputId = e.target.id

        if (inputId) {
            dispatchFieldChanges({ id: inputId, value: val })
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const validateFields = () => {
        const fieldsToValidate = document.querySelectorAll('[data-validate]');
        let valid = false;
        let contributeMentorChecked = false;
        let expInSalesforceChecked = false;

        contributeMentor.forEach(items => {
            if (inputValues[items]) {
                contributeMentorChecked = true;
            }
        })

        expInSalesforce.forEach(items => {
            if (inputValues[items]) {
                expInSalesforceChecked = true;
            }
        })

        fieldsToValidate.forEach(field => {
            let message = ''
            let hasAnyError = false;

            if (field.tagName === 'TDS-INPUT' && field.shadowRoot) {
                const value = field.shadowRoot.querySelector("input").value;
                if (field.type === "text" || field.type === "email" || field.type === "checkbox") {
                    if ((value.trim() === '' && field.dataset.validate === 'FirstName') || (value !== '' && field.dataset.validate === 'FirstName' && FormUtils.isValidUrl(value))) {
                        message = 'Please enter first name.'
                        hasAnyError = true
                    }
                    else if ((value.trim() === '' && field.dataset.validate === 'LastName') || (value !== '' && field.dataset.validate === 'LastName' && FormUtils.isValidUrl(value))) {
                        message = 'Please enter last name.'
                        hasAnyError = true
                    }
                    else if (value === '' && field.dataset.validate === 'Email' || value !== '' && field.dataset.validate === 'Email' && !FormUtils.isValidEmail(value)) {
                        message = 'Please enter valid email. example@yourdomain.com'
                        hasAnyError = true
                    }
                    else if ((value.trim() === '' && field.dataset.validate === 'Title') || (value !== '' && field.dataset.validate === 'Title' && FormUtils.isValidUrl(value))) {
                        message = 'Please enter job title.'
                        hasAnyError = true
                    }
                    else if ((value.trim() === '' && field.dataset.validate === 'Company') || (value !== '' && field.dataset.validate === 'Company' && FormUtils.isValidUrl(value))) {
                        message = 'Please enter company name.'
                        hasAnyError = true
                    }
                    else if (value === '' && field.dataset.validate === 'LinkedIn_URL' || value !== '' && field.dataset.validate === 'LinkedIn_URL' && !FormUtils.isValidUrl(value)) {
                        message = 'Please enter your valid Linkedin profile. Must be a url http://www.example.com/'
                        hasAnyError = true
                    }

                    else if ((value.trim() === '' && field.dataset.validate === 'ReferrerName') || (value !== '' && field.dataset.validate === 'ReferrerName' && FormUtils.isValidUrl(value))) {
                        message = 'Please enter referrer first name.'
                        hasAnyError = true
                    }
                    else if ((value.trim() === '' && field.dataset.validate === 'ReferrerLastName') || (value !== '' && field.dataset.validate === 'ReferrerLastName' && FormUtils.isValidUrl(value))) {
                        message = 'Please enter referrer last name.'
                        hasAnyError = true
                    }
                    else if (value === '' && field.dataset.validate === 'Referreremail' || value !== '' && field.dataset.validate === 'Referreremail' && !FormUtils.isValidEmail(value)) {
                        message = 'Please enter referrer email. example@yourdomain.com'
                        hasAnyError = true
                    }
                    else if (value === '' && field.dataset.validate === 'ReferrerURL' || value !== '' && field.dataset.validate === 'ReferrerURL' && !FormUtils.isValidUrl(value)) {
                        message = 'Please enter referrer Linkedin profile. Must be a url http://www.example.com/'
                        hasAnyError = true
                    }
                    else if (inputValues['termsAndCondition']?.showLegalCheckbox && field.id === 'legalText' && (inputValues['legalText'] === false || !inputValues['legalText'])) {
                        message = 'Please Accept the Privacy Statement'
                        hasAnyError = true
                    }
                }
            }

            if (field.tagName === 'TDS-COMBOBOX' && field.shadowRoot) {
                if (field.id === 'Country' && !inputValues['Country']) {
                    message = 'Please select the country.'
                    hasAnyError = true
                }
                else if (field.id === 'mulesoftCertified' && !inputValues['mulesoftCertified']) {
                    message = 'This field is required.'
                    hasAnyError = true
                }
                else if (field.id === 'role' && !inputValues['role']) {
                    message = 'Please select the role.'
                    hasAnyError = true
                }
            }

            if (field.tagName === 'TDS-TEXTAREA' && field.shadowRoot) {
                const value = field.shadowRoot.querySelector("textarea").value

                if (value === '' && field.dataset.validate === 'mulesoftMentorreasons') {
                    message = `This field is required.`
                    hasAnyError = true
                }

                else if (value === '' && field.dataset.validate === 'howdoyouknowthisperson') {
                    message = `This field is required.`
                    hasAnyError = true
                }

                else if (value === '' && field.dataset.validate === 'goodMulesoftMentor') {
                    message = `This field is required.`
                    hasAnyError = true
                }
            }

            if (hasAnyError) {
                valid = hasAnyError;
                dispatchFieldErrorsChanges({ id: field.id, value: message })

            } else {
                dispatchFieldErrorsChanges({ id: field.id, value: null })
            }
        })

        if (formType === 'applyyourself') {
            if (contributeMentorChecked === false) {
                valid = true;
                dispatchFieldErrorsChanges({ id: 'contributedMentor', value: 'This field is required.' })
            } else {
                dispatchFieldErrorsChanges({ id: 'contributedMentor', value: null })
            }

            if (expInSalesforceChecked === false) {
                valid = true;
                dispatchFieldErrorsChanges({ id: 'expInSalesforce', value: 'This field is required.' })
            } else {
                dispatchFieldErrorsChanges({ id: 'expInSalesforce', value: null })
            }
        }

        if (!recaptchaToken) {
            valid = true;
            let recaptchaError = 'Please complete the re-captcha verification.';
            showRecaptchaValidation(recaptchaError);
            dispatchFieldErrorsChanges({ id: 'recaptcha-widget', value: recaptchaError });
        } else {
            showRecaptchaValidation('');
            dispatchFieldErrorsChanges({ id: 'recaptcha-widget', value: null });
        }

        return valid;

    }

    const handleTdsInputOnChange = useCallback(e => {
        const val = e.nativeEvent ? e.nativeEvent.target.value : e.detail
        const inputId = e.target.id
        if (inputId) {
            dispatchFieldChanges({ id: inputId, value: val });
        }
    }, []);

    const handleTdsComboboxOnChange = useCallback(e => {
        const val = e.nativeEvent ? e.nativeEvent.target.value : e.detail
        const inputId = e.target.id
        if (inputId) {
            if (e.target.multiple) {
                const arr = JSON.parse(JSON.stringify(val))
                dispatchFieldChanges({ id: inputId, value: arr })

            } else {
                dispatchFieldChanges({ id: inputId, value: val })
            }
        }
    });

    const asyncPrepareFields = async () => {
        const tdsElementNames = ['tds-input', 'tds-combobox', 'tds-checkbox', 'tds-textarea']

        const promises = [...tdsElementNames].map(element => {
            if (element === "tds-input") {
                customElements.whenDefined("tds-input").then(() => {
                    document.querySelectorAll("tds-input").forEach(input => {
                        if (input.dataset && !Object.hasOwnProperty.call(input.dataset, 'onChangeBinded')) {
                            // Add Event Listener
                            input.addEventListener('change', handleTdsInputOnChange)
                            input.dataset.onChangeBinded = true
                        }
                    })
                })
            }

            if (element === "tds-combobox") {
                customElements.whenDefined("tds-combobox").then(() => {
                    document.querySelectorAll("tds-combobox").forEach(input => {
                        if (input.dataset && !Object.hasOwnProperty.call(input.dataset, 'onChangeBinded')) {
                            input.dataset.onChangeBinded = true
                            // Add Event Listener
                            input.addEventListener('change', handleTdsComboboxOnChange)
                        }
                    })
                })
            }

            if (element === "tds-textarea") {
                customElements.whenDefined("tds-textarea").then(() => {
                    document.querySelectorAll("tds-textarea").forEach(input => {
                        if (input.dataset && !Object.hasOwnProperty.call(input.dataset, 'onChangeBinded')) {
                            input.dataset.onChangeBinded = true
                            // Add Event Listener
                            input.addEventListener('change', handleTdsTextareaOnChange)
                        }
                    })
                })
            }
        })

        // Wait for all the undefinedElements to be defined
        await Promise.all(promises)
    }

    const getDropdownsOptions = () => {
        return {
            role: [
                'Architect',
                'Business Analyst',
                'Business Executive',
                'Consultant / Agency',
                'CTO / Chief Architect',
                'Developer / Engineer',
                'DevOps',
                'Digital / Innovation Leadership',
                'IT - Analyst',
                'IT - CIO',
                'IT - Dir / VP',
                'IT - Mgr / Professional',
                'Job Seeker / Student',
                'Marketing / Sales',
                'Program / Product Manager',
                'Other'
            ],
            mulesoftSalesforceExp: [
                'Anypoint Platform',
                'MuleSoft Composer',
                'MuleSoft RPA',
                'Salesforce Cloud Products',
                'Tableau',
                'Slack',
                'None of the above'
            ],
            mulesoftCertified: [
                'Yes',
                'No'
            ],
            trailblazerMember: [
                'Yes',
                'No'
            ]
        }
    }

    const showRecaptchaValidation = (msg) => {
        let errorDiv = document.querySelector('#recaptcha-error').parentElement

        if (msg) {
            errorDiv.classList.add('slds-has-error')
        }
        else {
            errorDiv.classList.remove('slds-has-error')
        }
    }

    const handleRecaptchaFail = () => {
        setRecaptchaToken('')
    }

    const handleRecaptcha = (value) => {
        setRecaptchaToken(value)
    }

    return (
        <LWCLayout slug={pageContext?.slug}>
            <Helmet>
                <title>Mulesoft Mentors Form</title>
            </Helmet>
            {isSiteDown && isSiteDown['isOpened'] ?
                <div className="mulesoft-content">
                    {urlError && (
                        <div className='page-error'>Please check your Url Query Params, the page you are looking for is does not exist.</div>
                    )}
                    {((formType === 'applyyourself' && isLoggedUser) || (formType === 'nominateSomeone')) && (
                        <>
                            {!apiMessage?.status && (
                                <>
                                    <div className="header-section">
                                        <div><img src="https://developer.salesforce.com/resources2/images/mulesoft-mentors-logo.png" width="50px" height="50px" alt="mulesoft mentors logo" /></div>
                                        {formType === 'applyyourself' && (
                                            <h1 className="main-title">Apply to become a MuleSoft Mentor</h1>
                                        )}

                                        {formType === 'nominateSomeone' && (
                                            <h1 className="main-title">Nominate someone to become a MuleSoft Mentor</h1>
                                        )}
                                        <p className="title-desc">Please fill out the form below </p>
                                    </div>
                                    {formType === 'nominateSomeone' && (
                                        <div className='nominee-txt'>Nominee information</div>
                                    )}

                                    <div className="flex-container">
                                        <div className="flex-item">
                                            <div className="u-input-label">
                                                <span className="u-required-simbol">*</span>
                                                First Name
                                            </div>
                                            <tds-input
                                                type="text"
                                                id="FirstName"
                                                placeholder="Enter First Name"
                                                required="true"
                                                data-validate="FirstName"
                                                value={inputValues['FirstName']}
                                                error-message={fieldErrors['FirstName']}
                                            />
                                        </div>
                                        <div className="flex-item mobile-top">
                                            <div className="u-input-label">
                                                <span className="u-required-simbol">*</span>
                                                Last Name
                                            </div>
                                            <tds-input
                                                type="text"
                                                id="LastName"
                                                placeholder="Enter Last Name"
                                                required="true"
                                                data-validate="LastName"
                                                value={inputValues['LastName']}
                                                error-message={fieldErrors['LastName']}
                                            />
                                        </div>
                                    </div>

                                    <div className="flex-container">
                                        <div className="flex-item">
                                            <div className="u-input-label">
                                                <span className="u-required-simbol">*</span>
                                                Email
                                            </div>
                                            <tds-input
                                                type="text"
                                                id="Email"
                                                placeholder="Enter Email"
                                                required="true"
                                                data-validate="Email"
                                                value={inputValues['Email']}
                                                error-message={fieldErrors['Email']}
                                            />
                                        </div>
                                        <div className="flex-item mobile-top">
                                            <div className="u-input-label">
                                                <span className="u-required-simbol">*</span>
                                                Job Title
                                            </div>
                                            <tds-input
                                                type="text"
                                                id="Title"
                                                placeholder="Enter Job Title"
                                                required="true"
                                                data-validate="Title"
                                                value={inputValues['Title']}
                                                error-message={fieldErrors['Title']}
                                            />
                                        </div>
                                    </div>

                                    <div className="flex-container">
                                        <div className="flex-item">
                                            <div className="u-input-label">
                                                <span className="u-required-simbol">*</span>
                                                Company
                                            </div>
                                            <tds-input
                                                type="text"
                                                id="Company"
                                                placeholder="Enter Company"
                                                required="true"
                                                data-validate="Company"
                                                value={inputValues['Company']}
                                                error-message={fieldErrors['Company']}
                                            />
                                        </div>
                                        <div className="flex-item mobile-top">
                                            <div className="u-input-label">
                                                <span className="u-required-simbol">*</span>
                                                Country
                                            </div>
                                            <tds-combobox
                                                id="Country"
                                                required="true"
                                                placeholder="Select one"
                                                data-validate="Country"
                                                value={inputValues['Country']}
                                                error-message={fieldErrors['Country']}
                                            />
                                        </div>
                                    </div>

                                    <div className="flex-container">
                                        <div className="flex-item">
                                            <div className="u-input-label">
                                                <span className="u-required-simbol">*</span>
                                                Linkedin Profile
                                            </div>
                                            <tds-input
                                                type="text"
                                                id="LinkedIn_URL"
                                                placeholder="Enter Linkedin Profile"
                                                required="true"
                                                data-validate="LinkedIn_URL"
                                                value={inputValues['LinkedIn_URL']}
                                                error-message={fieldErrors['LinkedIn_URL']}
                                            />
                                        </div>
                                        <div className="flex-item mobile-top">
                                            <div className="u-input-label">
                                                <span className="u-required-simbol">*</span>
                                                Role
                                            </div>
                                            <tds-combobox
                                                id="role"
                                                required="true"
                                                placeholder="Select one"
                                                data-validate="role"
                                                value={inputValues['role']}
                                                error-message={fieldErrors['role']}
                                            />
                                        </div>
                                    </div>

                                    {formType === 'applyyourself' && (
                                        <div className="flex-container">
                                            <div className="flex-item">
                                                <div className="u-input-label">
                                                    <span className="u-required-simbol">*</span>
                                                    Are you MuleSoft Certified?
                                                </div>
                                                <tds-combobox
                                                    id="mulesoftCertified"
                                                    required="true"
                                                    placeholder="Select one"
                                                    data-validate="mulesoftCertified"
                                                    value={inputValues['mulesoftCertified']}
                                                    error-message={fieldErrors['mulesoftCertified']}
                                                />
                                            </div>
                                            <div className="flex-item"></div>
                                        </div>
                                    )}

                                    {formType === 'applyyourself' && (
                                        <>
                                            <div className="margin-top">
                                                <div className="u-input-label">
                                                    <span className="u-required-simbol">*</span>
                                                    Why do you want to be a MuleSoft Mentor?
                                                </div>
                                                <tds-textarea
                                                    id="mulesoftMentorreasons"
                                                    required="true"
                                                    data-validate='mulesoftMentorreasons'
                                                    error-message={fieldErrors['mulesoftMentorreasons']}
                                                />
                                            </div>

                                            <div className="margin-top">
                                                <div className="u-input-label">
                                                    <span className="u-required-simbol">*</span>
                                                    How do you plan to contribute as a Mentor?
                                                </div>
                                                <div className="flex-container">
                                                    <div className="flex-item">
                                                        <p className='padding-checkbox'>
                                                            <tds-input id={contributeMentor[0]} label={contributeMentor[0]} type="checkbox" />
                                                        </p>
                                                        <p className='padding-checkbox'>
                                                            <tds-input id={contributeMentor[1]} label={contributeMentor[1]} type="checkbox" />
                                                        </p>
                                                        <p className='padding-checkbox'>
                                                            <tds-input id={contributeMentor[2]} label={contributeMentor[2]} type="checkbox" />
                                                        </p>
                                                        <p className='padding-checkbox'>
                                                            <tds-input id={contributeMentor[3]} label={contributeMentor[3]} type="checkbox" />
                                                        </p>
                                                    </div>
                                                    <div className="flex-item">
                                                        <p className='padding-checkbox'>
                                                            <tds-input id={contributeMentor[4]} label={contributeMentor[4]} type="checkbox" />
                                                        </p>
                                                        <p className='padding-checkbox'>
                                                            <tds-input id={contributeMentor[5]} label={contributeMentor[5]} type="checkbox" />
                                                        </p>
                                                        <p className='padding-checkbox'>
                                                            <tds-input id={contributeMentor[6]} label={contributeMentor[6]} type="checkbox" />
                                                        </p>

                                                    </div>
                                                </div>
                                                {fieldErrors['contributedMentor'] && (
                                                    <div className='input-error'>{fieldErrors['contributedMentor']}</div>
                                                )}
                                            </div>

                                            <div className="margin-top">
                                                <div className="u-input-label">
                                                    <span className="u-required-simbol">*</span>
                                                    What MuleSoft and/or Salesforce Products do you have experience using?
                                                </div>
                                                <div className="flex-container">
                                                    <div className="flex-item">
                                                        <p className='padding-checkbox'>
                                                            <tds-input id={expInSalesforce[0]} label={expInSalesforce[0]} type="checkbox" />
                                                        </p>
                                                        <p className='padding-checkbox'>
                                                            <tds-input id={expInSalesforce[1]} label={expInSalesforce[1]} type="checkbox" />
                                                        </p>
                                                        <p className='padding-checkbox'>
                                                            <tds-input id={expInSalesforce[2]} label={expInSalesforce[2]} type="checkbox" />
                                                        </p>
                                                        <p className='padding-checkbox'>
                                                            <tds-input id={expInSalesforce[3]} label={expInSalesforce[3]} type="checkbox" />
                                                        </p>
                                                    </div>
                                                    <div className="flex-item">
                                                        <p className='padding-checkbox'>
                                                            <tds-input id={expInSalesforce[4]} label={expInSalesforce[4]} type="checkbox" />
                                                        </p>
                                                        <p className='padding-checkbox'>
                                                            <tds-input id={expInSalesforce[5]} label={expInSalesforce[5]} type="checkbox" />
                                                        </p>
                                                        <p className='padding-checkbox'>
                                                            <tds-input id={expInSalesforce[6]} label={expInSalesforce[6]} type="checkbox" />
                                                        </p>

                                                    </div>
                                                </div>
                                                {fieldErrors['expInSalesforce'] && (
                                                    <div className='input-error'>{fieldErrors['expInSalesforce']}</div>
                                                )}
                                            </div>

                                            <div className="margin-top">
                                                <div className="u-input-label">
                                                    Are you a member of the Salesforce Trailblazer Community?
                                                </div>
                                                <tds-combobox
                                                    id="trailblazerMember"
                                                    required="true"
                                                    placeholder="Select one"
                                                    data-validate="trailblazerMember"
                                                    value={inputValues['trailblazerMember']}
                                                    error-message={fieldErrors['trailblazerMember']}
                                                />
                                            </div>
                                        </>
                                    )}

                                    {formType === 'nominateSomeone' && (
                                        <>
                                            <div className="margin-top">
                                                <div className="u-input-label">
                                                    <span className="u-required-simbol">*</span>
                                                    How do you know the person you’re nominating?
                                                </div>
                                                <tds-textarea
                                                    id="howdoyouknowthisperson"
                                                    required="true"
                                                    data-validate="howdoyouknowthisperson"
                                                    error-message={fieldErrors['howdoyouknowthisperson']}
                                                />
                                            </div>

                                            <div className="margin-top">
                                                <div className="u-input-label">
                                                    <span className="u-required-simbol">*</span>
                                                    Why would this person be a good MuleSoft Mentor?
                                                </div>
                                                <tds-textarea
                                                    id="goodMulesoftMentor"
                                                    required="true"
                                                    data-validate="goodMulesoftMentor"
                                                    error-message={fieldErrors['goodMulesoftMentor']}
                                                />
                                            </div>

                                            <div className='nominee-txt'>Referrer information</div>

                                            <div className="flex-container">
                                                <div className="flex-item">
                                                    <div className="u-input-label">
                                                        <span className="u-required-simbol">*</span>
                                                        First Name
                                                    </div>
                                                    <tds-input
                                                        type="text"
                                                        id="ReferrerName"
                                                        placeholder="Enter First Name"
                                                        required="true"
                                                        data-validate="ReferrerName"
                                                        value={inputValues['ReferrerName']}
                                                        error-message={fieldErrors['ReferrerName']}
                                                    />
                                                </div>
                                                <div className="flex-item mobile-top">
                                                    <div className="u-input-label">
                                                        <span className="u-required-simbol">*</span>
                                                        Last Name
                                                    </div>
                                                    <tds-input
                                                        type="text"
                                                        id="ReferrerLastName"
                                                        placeholder="Enter Last Name"
                                                        required="true"
                                                        data-validate="ReferrerLastName"
                                                        value={inputValues['ReferrerLastName']}
                                                        error-message={fieldErrors['ReferrerLastName']}
                                                    />
                                                </div>
                                            </div>

                                            <div className="flex-container">
                                                <div className="flex-item">
                                                    <div className="u-input-label">
                                                        <span className="u-required-simbol">*</span>
                                                        Email
                                                    </div>
                                                    <tds-input
                                                        type="text"
                                                        id="Referreremail"
                                                        placeholder="Enter Email"
                                                        required="true"
                                                        data-validate="Referreremail"
                                                        value={inputValues['Referreremail']}
                                                        error-message={fieldErrors['Referreremail']}
                                                    />
                                                </div>
                                                <div className="flex-item mobile-top">
                                                    <div className="u-input-label">
                                                        <span className="u-required-simbol">*</span>
                                                        Linkedin Profile
                                                    </div>
                                                    <tds-input
                                                        type="text"
                                                        id="ReferrerURL"
                                                        placeholder="Enter Linkedin Profile"
                                                        required="true"
                                                        data-validate="ReferrerURL"
                                                        value={inputValues['ReferrerURL']}
                                                        error-message={fieldErrors['ReferrerURL']}
                                                    />
                                                </div>
                                            </div>
                                        </>
                                    )}

                                    {inputValues['termsAndCondition']?.showMarketingText && (
                                        <div className="fifth-page margin-top">
                                            <tds-input type="checkbox" id="Privacy_Consent__c" label={inputValues['termsAndCondition']?.marketingText} />
                                        </div>
                                    )}

                                    {inputValues['termsAndCondition']?.legalText && (
                                        <div className="sixth-page margin-top">
                                            {inputValues['termsAndCondition']?.showLegalCheckbox && (
                                                <tds-input
                                                    className={`display-inline`}
                                                    type="checkbox"
                                                    id="legalText"
                                                    data-validate='legalCheckbox'
                                                />
                                            )}
                                            <span
                                                className='legal-txt'
                                                dangerouslySetInnerHTML={{
                                                    __html:
                                                        inputValues['termsAndCondition']?.legalText
                                                }}
                                            />
                                            {fieldErrors['legalText'] && (
                                                <div className="legal-txt-error">{fieldErrors['legalText']}</div>
                                            )}
                                            {inputValues['termsAndCondition']?.learnMore && (
                                                <p
                                                    className="learn-more-txt"
                                                    dangerouslySetInnerHTML={{
                                                        __html:
                                                            inputValues['termsAndCondition']?.learnMore
                                                    }} />
                                            )}
                                        </div>
                                    )}

                                    <div className='privacy-statement'>
                                        <div class="slds-form-element slds-m-top_large" id="recaptcha-widget">
                                            <ReCAPTCHA
                                                ref={recaptchaRef}
                                                sitekey={process.env.GATSBY_OPTIN_RESEARCH_RECAPTCHA_SITE_KEY}
                                                onChange={handleRecaptcha}
                                                onExpired={handleRecaptchaFail}
                                                onErrored={handleRecaptchaFail} />
                                        </div>
                                        <div class="slds-form-element__help" id="recaptcha-error">{fieldErrors['recaptcha-widget']} </div>
                                    </div>

                                    <div className="slds-p-around_small slds-m-top_large">
                                        <div className="slds-m-vertical_xx-large slds-text-align_center">
                                            {isLoading ?
                                                <>
                                                    <div className="loader"></div>
                                                    <span className="loading-text">Loading....</span> </> :
                                                <tds-button variant="brand" onClick={handleSubmitForm}>SUBMIT APPLICATION</tds-button>
                                            }
                                        </div>
                                    </div>
                                </>
                            )}

                            {apiMessage?.status && (
                                <div className='success-page'>
                                    <img src="https://developer.salesforce.com/resources2/images/mulesoft-mentors-logo.png" width="50px" height="50px" alt="mulesoft mentors logo" />
                                    {apiMessage?.status === 'success' ?
                                        <>
                                            <p className='title'>
                                                {formType === 'applyyourself' && <span>Thank you for applying!</span>}
                                                {formType === 'nominateSomeone' && <span>Thank you for the nomination!</span>}
                                            </p>
                                            <p className='desc'>
                                                {formType === 'applyyourself' && <span>Look for a confirmation email. You’ll now be redirected back to MuleSoft. </span>}

                                                {formType === 'nominateSomeone' && <span>You'll now be redirected back to MuleSoft.</span>}
                                            </p>
                                        </>
                                        :
                                        <p className='error-txt'>Error: your form did not submit correctly. Please contact <u>community@mulesoft.com</u></p>
                                    }
                                </div>
                            )}
                        </>
                    )}
                </div> :
                <div className='site-down-alert'>
                    {isSiteDown && !isSiteDown['isOpened'] && (
                        <article>
                            <h1>MuleSoft Mentor Application Closed</h1>
                            <h3>The MuleSoft Mentor Application is currently closed and will not be available from {isSiteDown && isSiteDown['startDateInfo']} to {isSiteDown && isSiteDown['endDateInfo']}. The application form will reopen on {isSiteDown && isSiteDown['formOpenDate']} and remain open until {isSiteDown && isSiteDown['formEndDate']}. We encourage you to check back during this time to submit your application. Thank you for your interest, and we look forward to your application!</h3>
                        </article>
                    )}
                </div>
            }
        </LWCLayout>
    )
}

export default MulesoftMentors;